const PRIMARY_PRIORITY_FOLDERS = new Set([
  'ohne',
  'XLquer',
  'XLquerK29',
  'XLhoch',
  'XLhochK29',
  'KK',
  'KS',
  'KW',
]);

const XL_HOCH_K29_MIN_DIMENSION = 1500;

const toDimensionNumber = value => {
  const normalized = String(value ?? '').trim().replace(',', '.');
  if (normalized === '') return null;

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
};

export const shouldUseXLhochK29 = (width, height, hasXLProfile) => {
  if (!hasXLProfile) return false;

  const parsedWidth = toDimensionNumber(width);
  const parsedHeight = toDimensionNumber(height);

  return parsedWidth !== null
    && parsedHeight !== null
    && parsedWidth >= XL_HOCH_K29_MIN_DIMENSION
    && parsedHeight >= XL_HOCH_K29_MIN_DIMENSION;
};

export const getConfiguredDimensions = (items = []) => {
  for (const item of items || []) {
    const value = String(item?.value ?? item?.emptyValue ?? '');
    const match = value.match(/(-?\d+(?:[.,]\d+)?)\s*(?:mm)?\s*x\s*(-?\d+(?:[.,]\d+)?)/i);
    if (match) {
      return { width: match[1], height: match[2] };
    }
  }

  return { width: null, height: null };
};

export const replacePrimaryPriorityFolder = (priorityFolders, nextPrimary) => {
  const parts = String(priorityFolders || '')
    .split(',')
    .map(part => part.trim())
    .filter(Boolean);

  if (parts.length > 0 && PRIMARY_PRIORITY_FOLDERS.has(parts[0])) {
    parts[0] = nextPrimary;
  } else {
    parts.unshift(nextPrimary);
  }

  return Array.from(new Set(parts)).join(',');
};
